<template>
  <v-dialog v-model="dialog" max-width="460px">
    <v-card class="credit-card">
      <DialogTitleBar>
        <span>크레딧 부족</span>
        <template #actions>
          <v-btn icon variant="text" aria-label="닫기" @click="close">
            <svg-icon type="mdi" :path="icons.mdiClose" />
          </v-btn>
        </template>
      </DialogTitleBar>

      <v-card-text>
        <p class="dialog-intro">특기사항을 생성하려면 크레딧이 더 필요합니다.</p>
        <div class="credit-summary">
          <div><span>현재 크레딧</span><strong>{{ formatCredit(credit) }}</strong></div>
          <div><span>필요 크레딧</span><strong>{{ formatCredit(requiredCredit) }}</strong></div>
          <div class="shortage"><span>부족 크레딧</span><strong>{{ formatCredit(shortageCredit) }}</strong></div>
        </div>
        <v-alert type="warning" variant="tonal" density="compact" class="mt-4">
          충전 페이지로 이동하면 현재 작성 화면에서 벗어납니다. 자동 저장이 꺼져 있다면 작성 내용을 먼저 확인해 주세요.
        </v-alert>
        <p class="move-question">크레딧 충전 페이지로 이동하시겠습니까?</p>
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <v-btn variant="text" @click="close">계속 작성</v-btn>
        <v-btn color="primary" @click="goToPayment">충전 페이지로 이동</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import DialogTitleBar from '@/components/DialogTitleBar.vue';
import icons from '@/icons';

export default {
  name: 'CreditDialog',
  components: { DialogTitleBar },
  props: {
    modelValue: { type: Boolean, default: false },
    credit: { type: Number, required: true },
    requiredCredit: { type: Number, default: 0 },
  },
  emits: ['update:modelValue'],
  data() {
    return { dialog: false, icons };
  },
  computed: {
    shortageCredit() {
      return Math.max(Number(this.requiredCredit || 0) - Number(this.credit || 0), 0);
    },
  },
  watch: {
    modelValue: {
      immediate: true,
      handler(value) {
        this.dialog = value;
      },
    },
    dialog(value) {
      this.$emit('update:modelValue', value);
    },
  },
  methods: {
    formatCredit(value) {
      return Number(value || 0).toLocaleString('ko-KR', { maximumFractionDigits: 2 }) + ' 크레딧';
    },
    close() {
      this.dialog = false;
    },
    goToPayment() {
      this.close();
      this.$router.push('/payment');
    },
  },
};
</script>

<style scoped>
.dialog-intro {
  margin: 4px 0 18px;
  color: rgba(0, 0, 0, 0.66);
}

.credit-summary {
  display: grid;
  gap: 10px;
  padding: 16px;
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 10px;
}

.credit-summary > div {
  display: flex;
  justify-content: space-between;
  gap: 16px;
}

.credit-summary span {
  color: rgba(0, 0, 0, 0.6);
}

.credit-summary .shortage strong {
  color: rgb(var(--v-theme-error));
}

.move-question {
  margin: 18px 0 0;
  font-weight: 600;
}
</style>
